import { observer } from 'mobx-react'
import React from 'react'
import { ButtonTH } from 'ui-framework'
import LendVM from '../LendVM'
import lendBean from './lend-bean.svg'
import lendOoki from './lend-ooki.svg'
import LendListItem from './LendListItem'

export function LendList({ vm }: { vm: LendVM }) {
  const { chain } = vm.rootStore
  const { media } = vm.rootStore.uiStore

  if (!chain) {
    return null
  }

  return (
    <div className="lend-list__container margin-bottom-4">
      <div className="padded-v-1 md-padded-h-2 lend-list__grid items-center lend__sort-btns">
        <ButtonTH
          onClick={vm.sortList}
          sortBy="asset"
          sortOrder={vm.sortOrder}
          currentSortBy={vm.sortBy}>
          Asset
        </ButtonTH>
        <ButtonTH
          onClick={vm.sortList}
          sortBy="supplyApr"
          sortOrder={vm.sortOrder}
          currentSortBy={vm.sortBy}>
          Lending Rate
        </ButtonTH>
        <ButtonTH
          onClick={vm.sortList}
          sortBy="liquidity"
          sortOrder={vm.sortOrder}
          currentSortBy={vm.sortBy}>
          Liquidity
        </ButtonTH>
      </div>

      {vm.filteredLendItems.map((item) => (
        <LendListItem key={item.asset} lendItemDetails={item} vm={vm} chain={chain} />
      ))}

      {vm.filteredLendItems.length === 0 && vm.searchQuery && (
        <p className="txt-center margin-top-2">
          <i>The filter returned 0 result.</i>
        </p>
      )}
      {!media.isMobileMedia && !vm.searchQuery && (
        <>
          <img src={lendOoki} className="lend__ooki-img" />
          <img src={lendBean} className="lend__bean-img" />
        </>
      )}
    </div>
  )
}

export default observer(LendList)
